export const columnDefs = [
    {
        checkboxSelection: true,
        headerCheckboxSelection: true,
    },
    {
        headerName: 'Named Insured',
        field: 'namedInsured',
    },
    {
        headerName: 'Class',
        field: 'classTypeName',
    },
    {
        headerName: 'Mailing Address',
        field: 'namedInsuredAddress',
    },
    {
        headerName: 'Mailing Address 2',
    },
    {
        headerName: 'City',
        field: 'namedInsuredCity',
    },
    {
        headerName: 'State',
        field: 'namedInsuredState',
    },
    {
        headerName: 'Zip',
        field: 'namedInsuredZip',
    },
    {
        headerName: 'Contact First & Last Name',
        field: 'inspectionContactName',
    },
    {
        headerName: 'Contact Phone',
        field: 'inspectionContactPhone',
    },
    {
        headerName: 'Contact Email',
        field: 'inspectionContactEmail',
    },
    {
        headerName: 'Inspection Location Name',
        field: 'locationName',
    },
    {
        headerName: 'Inspection Location Address 1',
        field: 'locationAddress',
    },
    {
        headerName: 'Inspection Location Address 2',
    },
    {
        headerName: 'City',
        field: 'locationCity',
    },
    {
        headerName: 'State',
        field: 'locationState',
    },
    {
        headerName: 'Zip',
        field: 'locationZip',
    },
    {
        headerName: 'Policy #',
        field: 'policyNumber',
    },
    {
        headerName: 'Premium',
    },
    {
        headerName: 'Policy Effective Date',
        field: 'submissionEffectiveDate',
    },
    {
        headerName: 'Policy Expiration Date',
    },
    {
        headerName: 'Agency Name',
        field: 'agencyName',
    },
    {
        headerName: 'Agent First & Last Name',
        field: 'agentName',
    },
    {
        headerName: 'Agent Phone',
        field: 'agentPhone',
    },
    {
        headerName: 'Agent Email',
        field: 'agentEmail',
    },
];
